module.exports = __webpack_public_path__ + "img/report3-2.a0bca7fb.png";